import { cn, CryptoIcon, SimpleSelectContent } from '@valiant/ui-shared'
import { ChevronDown } from 'lucide-react'
import { Select, SelectItem, SelectTrigger, SelectValue } from '@valiant/ui-shared'

interface Coin {
  symbol: string
  name: string
  image?: string | null
}

interface CoinSelectorProps {
  value: string
  onValueChange: (value: string) => void
  coins: Coin[]
  placeholder?: string
}

const BigChevronDownIcon = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'flex items-center justify-center bg-main rounded-md w-8 h-9 text-white',
      className,
    )}
  >
    <ChevronDown className="shrink-0 h-6 w-6 text-white" />
  </div>
)

export const CoinSelector = ({
  value,
  onValueChange,
  coins,
  placeholder = 'Select coin',
}: CoinSelectorProps) => {
  const selectedCoin = coins.find((coin) => coin.symbol === value)

  return (
    <div className="relative">
      <label className="text-sm font-medium text-gray-700 mb-2 block absolute top-0 -translate-y-1/2 left-4.5 bg-white px-1">
        Select Coin:
      </label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger
          className="w-full px-4.5 py-2.5 cursor-pointer"
          size="lg"
          OverrideChevron={BigChevronDownIcon}
        >
          <SelectValue placeholder={placeholder}>
            {selectedCoin && (
              <div className="flex items-center gap-2">
                <CryptoIcon
                  symbol={selectedCoin.symbol}
                  imageOverride={selectedCoin.image || undefined}
                  className="w-6 h-6"
                />
                <span className="text-lg font-semibold text-gray-900">{selectedCoin.symbol}</span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SimpleSelectContent>
          {coins.map((coin, index) => (
            <div key={coin.symbol}>
              <SelectItem value={coin.symbol} className="py-3">
                <div className="flex items-center gap-3">
                  <CryptoIcon
                    symbol={coin.symbol}
                    imageOverride={coin.image || undefined}
                    className="w-8 h-8"
                  />
                  <span className="text-lg font-bold text-gray-900">{coin.symbol}</span>
                </div>
              </SelectItem>
              {index < coins.length - 1 && <div className="border-b border-gray-200 mx-4" />}
            </div>
          ))}
        </SimpleSelectContent>
      </Select>
    </div>
  )
}
